<template>
	<div class="appDatetimeInput">
		<date-picker class="appDatetimeInput__input"
								 v-model="datetimeValuePicker"
								 :format="dateFormat"
								 :input-class="inputClassListLive"
								 :value-type="'format'"
								 :partial-update="true"
								 :lang="lang"
								 :type="pickerType"
								 :append-to-body="appendToBody"
								 :disabled="disabled"
								 @input="onPickerInputHandler"
								 @blur="onInputBlurHandler">
		</date-picker>
	</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
	name: 'DatetimeInput',

	props: {
		value: {type: [String, Date, Boolean], required: false, default: false},
		inputClassList: {type: [String, Array, Object], required: false, default: ''},
		pickerType: {type: String, required: false, default: "date"},
		dateFormat: {type: String, required: false, default: 'DD.MM.YYYY'},
		inputFormat: {type: String, required: false, default: 'YYYY-MM-DD'},
		outputFormat: {type: String, required: false, default: 'YYYY-MM-DD'},
		required: {type: Boolean, required: false, default: false},
		readonly: {type: Boolean, required: false, default: false},
		disabled: {type: Boolean, required: false, default: false},
		useIcon: {type: Boolean, required: false, default: true},
		confirm: {type: Boolean, required: false, default: false},
		appendToBody: {type: Boolean, required: false, default: true},
		id: {type: String, required: false, default: ''},
		name: {type: String, required: false, default: ''},
		placeholder: {type: String, required: false, default: ''}
	},

	computed: {
		datetimeValuePicker: {
			get() {
				return this.inputValue ? new Date(this.inputValue) : (
					this.value ? this.$moment(this.value, this.inputValue).format(this.dateFormat) : this.inputValue
				);
			},
			set(value) {
				if (this.$moment(value, [this.dateFormat], true).isValid()) {
					this.pickerValue = this.$moment(value, this.dateFormat).format(this.outputFormat);
				} else {
					this.pickerValue = value || null;
				}
				this.onPickerInputHandler();
			}
		},
		inputClassListLive() {
			return this.inputClassList;
		}
	},

	data() {
		return {
			pickerValue: null,
			inputValue: null,
			lang: {
				formatLocale: {
					// MMMM
					months: [
						this.$t('vforms.january'), this.$t('vforms.february'), this.$t('vforms.march'), this.$t('vforms.april'),
						this.$t('vforms.may'), this.$t('vforms.jun'), this.$t('vforms.july'), this.$t('vforms.augest'),
						this.$t('vforms.september'), this.$t('vforms.october'), this.$t('vforms.november'),
						this.$t('vforms.december')
					],
					// MMM
					monthsShort: [
						this.$t('vforms.short_january'), this.$t('vforms.short_february'), this.$t('vforms.short_march'),
						this.$t('vforms.short_april'), this.$t('vforms.short_may'), this.$t('vforms.short_jun'),
						this.$t('vforms.short_july'), this.$t('vforms.short_augest'), this.$t('vforms.short_september'),
						this.$t('vforms.short_october'), this.$t('vforms.short_november'), this.$t('vforms.short_december')
					],
					// dddd
					weekdays: [
						this.$t('vforms.sunday'), this.$t('vforms.monday'), this.$t('vforms.tuesday'), this.$t('vforms.wednesday'),
						this.$t('vforms.thursday'), this.$t('vforms.friday'), this.$t('vforms.saturday')
					],
					// ddd
					weekdaysShort: [
						this.$t('vforms.short_sunday'), this.$t('vforms.short_monday'), this.$t('vforms.short_tuesday'),
						this.$t('vforms.short_wednesday'), this.$t('vforms.short_thursday'), this.$t('vforms.short_friday'),
						this.$t('vforms.short_saturday')
					],
					// dd
					weekdaysMin: [
						this.$t('vforms.min_sunday'), this.$t('vforms.min_monday'), this.$t('vforms.min_tuesday'),
						this.$t('vforms.min_wednesday'), this.$t('vforms.min_thursday'), this.$t('vforms.min_friday'),
						this.$t('vforms.min_saturday')
					],
				}
			}
		};
	},

	methods: {
		onInputBlurHandler(value) {
			this.$emit('blur', this.pickerValue);
		},
		onPickerInputHandler(value) {
			this.$emit('input', this.pickerValue);
		}
	},

	components: {
		DatePicker
	}
};
</script>
